namespace e5 {
    export interface ClickOptions extends ActorOptions {
        maxDistance?: number;
        maxLifetime?: number;
        doubleClick?: boolean;
        doubleClickTime?: number;
        maxDoubleClickDistance?: number;
        repeatInterval?: number;
        repeatStartTime?: number;
    }

    export class PointerInfoClick extends Pointer {
        isClick: boolean = false;
        isDoubleClick: boolean = false;
    }

    export class Click extends Actor<PointerInfoClick, ClickOptions> implements ClickOptions {
        public static DEFAULT: ClickOptions = {
            maxDistance: 30,
            maxDoubleClickDistance: 30,
            maxLifetime: 1200,
            // maxPointers: 1,
            doubleClick: false,
            doubleClickTime: 400,
            repeatInterval: 200,
            repeatStartTime: 500
        };

        public onClick = e5.Signal.create<[PointerInfoClick, PointerInfoClick[], Click]>();
        public onDoubleClick = e5.Signal.create<[PointerInfoClick, PointerInfoClick[], Click]>();
        public onRepeat = e5.Signal.create<[number, Click]>();

        public maxLifetime: number;
        public maxDistance: number;
        public doubleClick: boolean;
        public doubleClickTime: number;
        public maxDoubleClickDistance: number;
        public repeatInterval: number;
        public repeatStartTime: number;

        constructor(element: HTMLElement = null, options: ClickOptions = null) {

            super(null, ActorNonOptions);

            if (options !== ActorNonOptions)
                this.setOptions(options);

            this.element = element;

            var repeatTimeout: any = 0;
            var repeatCount: any = 0;

            var triggerRepeat = () => {
                this.onRepeat.dispatch(++repeatCount, this);

                clearTimeout(repeatTimeout);

                var time = this.repeatStartTime;
                if (repeatCount > 1)
                    time = this.repeatInterval;
                repeatTimeout = setTimeout(() => triggerRepeat(), time);
            };

            this.onDown.add((pointers) => {
                if (this.pointers.length > 1)
                    return;
                if (repeatCount == 0)
                    triggerRepeat();
            });

            this.onUp.add((pointers) => {
                if (this.pointers.length > 0)
                    return;
                clearInterval(repeatTimeout);
                repeatCount = 0;
            });

            var lastClickX = NaN;
            var lastClickY = NaN;
            var lastClickTime = NaN;
            var clickTimeout: any = 0;

            this.onUp.add((pointers) => {
                if (this.count !== 0)
                    return;
                var lifeTime = Actor.lifetime(pointers);
                var pointer = pointers[0];

                if (!(pointer.distance <= this.maxDistance && lifeTime <= this.maxLifetime))
                    return;

                if (this.doubleClick) {
                    if (isNaN(lastClickX)) {
                        lastClickX = pointer.x;
                        lastClickY = pointer.y;
                        lastClickTime = (new Date()).getTime();

                        clickTimeout = setTimeout(() => {
                            var p = pointer;
                            var pts = pointers;
                            this.onClick.dispatch(p, pts, this);
                            lastClickX = NaN;
                        }, this.doubleClickTime + 5);
                    }
                    else {
                        var dx = pointer.x - lastClickX;
                        var dy = pointer.y - lastClickY;
                        var distance = Math.sqrt(dx * dx + dy * dy);
                        var deltaTime = (new Date()).getTime() - lastClickTime;

                        clearTimeout(clickTimeout);

                        if (deltaTime <= this.doubleClickTime && distance < this.maxDoubleClickDistance) {
                            for (var pointer of pointers)
                                pointer.isDoubleClick = true;
                            this.pointer.isDoubleClick = true;
                            this.onDoubleClick.dispatch(pointer, pointers, this);
                        } else {
                            this.onClick.dispatch(pointer, pointers, this);
                        }

                        lastClickX = NaN;
                    }
                }
                else
                {
                    pointer.isClick = true;
                    this.onClick.dispatch(pointer, pointers, this);
                }
            });
        }

        protected createPointer(): PointerInfoClick {
            return new PointerInfoClick();
        }

        public setOptions(options: ClickOptions) {
            options = ObjectUtil.extend({}, Click.DEFAULT, options);
            this.maxDistance = options.maxDistance;
            this.maxLifetime = options.maxLifetime;
            this.doubleClick = options.doubleClick;
            this.doubleClickTime = options.doubleClickTime;
            this.maxDoubleClickDistance = options.maxDoubleClickDistance;
            this.repeatInterval = options.repeatInterval;
            this.repeatStartTime = options.repeatStartTime;
            super.setOptions(options);
        }

        public dispose(): void {
            this.onClick.dispose();
            this.onClick = null;
            this.onDoubleClick.dispose();
            this.onDoubleClick = null;
            this.onRepeat.dispose();
            this.onRepeat = null;
            super.dispose();
        }
    }
}